module.exports = "<section id=\"flag\">\n</section>\n";